import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { SideNavService } from '../side-nav.service';
import { IMenuItem } from '@app/views/components/mainmenu/mainmenu.service';
import { GotoParms, StateService } from '@app/core/services/state.service';
import { UtilityService } from '@app/core/services/utility.service';
import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
// import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'tt-side-nav-item',
    templateUrl: './side-nav-item.component.html',
    styleUrls: ['./side-nav-item.component.css'],
    encapsulation: ViewEncapsulation.None,
    // animations: [trigger('sideNavExpand', [state('true', style({ height: '*', borderBottom: '0.1rem solid rgba(var(--tt-body-text-color-rgb), 0.1)' })), state('false', style({ height: '0px', borderBottom: '0' })), transition('false <=> true', animate('0.2s ease-in'))])],
})
export class SideNavItemComponent implements OnInit {
    @Input()
    public ttId: string | number = '';

    @Input()
    public ttText = '';

    @Input()
    public ttTabIndex: '-1' | '0' = '0';

    @Input()
    public set ttIcon(value: string) {
        this._icon = this.getIcon(value);
    }
    public get ttIcon(): string {
        return this._icon;
    }
    private _icon = '';

    @Input()
    public ttIconColor = '';

    @Input()
    public ttGoto = '';

    @Input()
    public ttGotoParms?: GotoParms<unknown>;

    @Output()
    public ttClick = new EventEmitter<MouseEvent | KeyboardEvent>();

    @Input()
    public ttExpanded = false;

    @Output()
    public ttExpandedChange = new EventEmitter<boolean>();

    @Input()
    public set ttExpandable(value: BooleanInput) {
        this._expandable = coerceBooleanProperty(value);
    }
    public get ttExpandable() {
        return this._expandable;
    }
    private _expandable = true;

    public children: IMenuItem[] = [];

    constructor(
        public sideNav: SideNavService,
        public state: StateService,
        public utility: UtilityService,
    ) {}

    public get expandable() {
        return this.children.length > 0 && this.ttExpandable;
    }

    ngOnInit(): void {
        this.sideNav.allSideNavItems$.subscribe({ next: (items) => (this.children = this.sideNav.getChildren(this.ttId, items)) });
    }

    public toggleExpansion(event: MouseEvent) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
        this.ttExpanded = !this.ttExpanded;
        this.ttExpandedChange.emit(this.ttExpanded);
    }

    public onClick(event: MouseEvent | KeyboardEvent) {
        if (!!this.ttGoto) {
            if (this.utility.isModifierKeyPressed(event)) {
                this.state.newTab(this.ttGoto, this.ttGotoParms);
            } else {
                this.state.go(this.ttGoto, this.ttGotoParms);
            }
        }

        this.ttClick.emit(event);
    }

    private getIcon(value: string): string {
        return value.replace('fas', 'fa');
    }
}
